import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
  Icon,
  Label,
  Button,
  Modal,
  Popup
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { mailConstants } from '../../constants/mail.constants';
import { getMailStatusLabel, getMailStatusColor, getMailTypeLabel } from '../../helpers/mail';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class MailLogScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      to: null,
      subject: null,
      status: null,
      type: null,
      period: '',
      detail: null,
    };
  }

  static get propTypes() {
    return {
      registers: PropTypes.any,
      loading: PropTypes.bool,
      dispatch: PropTypes.func,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);

    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period, page: 1 }, () => this.fetchRegisters());
  }

  handleSearchChange(field, value) {
    this.setState({ [field]: value, page: 1 });
    this.handleSearchDebounced();
  }

  handleFilterChange(field, value) {
    this.setState({ [field]: value, page: 1 }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, to, subject, status, type, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchMailLog({
      page, to, subject, status, type, startDate, endDate,
      orderBy: "Id", export: isExport ? true : null, ascending: false
    }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  statusOptions() {
    return [
      { key: 'all', value: null, text: 'Todas' },
      { key: mailConstants.MAIL_STATUS_SENT, value: mailConstants.MAIL_STATUS_SENT, text: getMailStatusLabel(mailConstants.MAIL_STATUS_SENT) },
      { key: mailConstants.MAIL_STATUS_FAILED, value: mailConstants.MAIL_STATUS_FAILED, text: getMailStatusLabel(mailConstants.MAIL_STATUS_FAILED) },
    ];
  }

  typeOptions() {
    const types = [
      mailConstants.MAIL_TYPE_REQUEST_CREATED,
      mailConstants.MAIL_TYPE_REQUEST_APPROVED,
      mailConstants.MAIL_TYPE_REQUEST_REJECTED,
      mailConstants.MAIL_TYPE_USER_WELCOME,
    ];

    return [{ key: 'all', value: null, text: 'Todos' }]
      .concat(types.map((type) => ({ key: type, value: type, text: getMailTypeLabel(type) })));
  }

  render() {
    const { registers, loading } = this.props;
    const { period, status, type, detail } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Histórico de E-mails</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Período'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Destinatário' onChange={(e, data) => this.handleSearchChange("to", data.value)} loading={loading} />
            <Form.Input icon='search' label='Assunto' onChange={(e, data) => this.handleSearchChange("subject", data.value)} loading={loading} />
            <Form.Select label='Situação' options={this.statusOptions()} value={status} onChange={(e, data) => this.handleFilterChange("status", data.value)} />
            <Form.Select label='Tipo' options={this.typeOptions()} value={type} onChange={(e, data) => this.handleFilterChange("type", data.value)} />

            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Data</Table.HeaderCell>
                <Table.HeaderCell>Destinatário</Table.HeaderCell>
                <Table.HeaderCell>Tipo</Table.HeaderCell>
                <Table.HeaderCell>Assunto</Table.HeaderCell>
                <Table.HeaderCell>Solicitação</Table.HeaderCell>
                <Table.HeaderCell>Situação</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { registers.Results.map((register) => {
                return <Table.Row key={register.Id} error={register.Status == mailConstants.MAIL_STATUS_FAILED}>
                  <Table.Cell>{register.Date ? moment(register.Date).format('DD/MM/YYYY HH:mm:ss') : '-'}</Table.Cell>
                  <Table.Cell>{register.ToName ? `${register.ToName} <${register.To}>` : register.To}</Table.Cell>
                  <Table.Cell>{getMailTypeLabel(register.Type)}</Table.Cell>
                  <Table.Cell>{register.Subject ?? '-'}</Table.Cell>
                  <Table.Cell>{register.RequestId ? `#${register.RequestId}` : '-'}</Table.Cell>
                  <Table.Cell>
                    <Label color={getMailStatusColor(register.Status)}>{getMailStatusLabel(register.Status)}</Label>
                    {register.Error && <Popup content={register.Error} trigger={<Icon name='warning circle' color='red' />} />}
                  </Table.Cell>
                  <Table.Cell>
                    <Button size='mini' icon='eye' type='button' title='Ver conteúdo' onClick={() => this.setState({ detail: register })} />
                    {register.Attachments && register.Attachments.map((attachment) => (
                      <Popup
                        key={attachment.Id}
                        content={attachment.FileName}
                        trigger={
                          <Button
                            size='mini'
                            icon='download'
                            type='button'
                            onClick={() => this.props.dispatch(reportActions.downloadMailLogAttachment(attachment))}
                          />
                        }
                      />
                    ))}
                  </Table.Cell>
                </Table.Row>;
              }) }
            </Table.Body>
          </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />

        <Modal open={!!detail} onClose={() => this.setState({ detail: null })} closeIcon>
          <Modal.Header>{detail?.Subject}</Modal.Header>
          <Modal.Content scrolling>
            <p>
              <strong>Para:</strong> {detail?.ToName ? `${detail.ToName} <${detail.To}>` : detail?.To}<br />
              <strong>Data:</strong> {detail?.Date ? moment(detail.Date).format('DD/MM/YYYY HH:mm:ss') : '-'}<br />
              <strong>Situação:</strong> {getMailStatusLabel(detail?.Status)}
            </p>
            {detail?.Error && <p><strong>Erro:</strong> {detail.Error}</p>}
            {detail?.Attachments && detail.Attachments.length > 0 &&
              <p>
                <strong>Anexos:</strong><br />
                {detail.Attachments.map((attachment) => (
                  <Button
                    key={attachment.Id}
                    size='mini'
                    icon='download'
                    content={attachment.FileName}
                    type='button'
                    onClick={() => this.props.dispatch(reportActions.downloadMailLogAttachment(attachment))}
                    style={{ marginTop: '4px' }}
                  />
                ))}
              </p>}
            {detail?.Body
              ? <iframe
                  title='Conteúdo do e-mail'
                  srcDoc={detail.Body}
                  sandbox=''
                  style={{ width: '100%', height: '60vh', border: '1px solid #e0e0e0' }}
                />
              : <p><i>O conteúdo deste e-mail não é armazenado.</i></p>}
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.setState({ detail: null })}>Fechar</Button>
          </Modal.Actions>
        </Modal>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;

  return {
    registers: report?.mailLogs || null,
    loading: report?.loading
  };
}

const connectedMailLogScreen = connect(mapStateToProps)(MailLogScreen);
export { connectedMailLogScreen as MailLogScreen };
